/**
 * No operation function
 * @returns (undefined)
 */
export function noOpFunction() {}
